import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'
import { wrapCreateBrowserRouterV6 } from '@sentry/react'
import { ServiceError } from 'entities/Sentry/ui/ServiceError'
import { type EntitiesStore } from 'entities/EntitiesExport'
import { ProviderEntities } from 'entities/EntitiesExport/context/entitiesContext'
import { PresentationModeLayout } from 'widgets/PresentationMode'
import { ProviderCallPopUpGlobal } from 'widgets/CallPopUp/context/callPopUpGlobalContext'
import type { CallPopUpGlobalStore } from 'widgets/CallPopUp'
import BannerLayout from './layouts/BannerLayout'

const routes = createRoutesFromElements(
  <Route element={<PresentationModeLayout />}>
    <Route
      path='/*'
      element={<BannerLayout />}
      errorElement={<ServiceError name='banner_layout' />}
    />
  </Route>
)

const router = wrapCreateBrowserRouterV6(createBrowserRouter)(routes)

type IBannerServiceProps = {
  entities: EntitiesStore
  callPopUpGlobalStore: CallPopUpGlobalStore
}

export const BannerService = ({ entities, callPopUpGlobalStore }: IBannerServiceProps) => (
  <ProviderEntities entities={entities}>
    <ProviderCallPopUpGlobal value={callPopUpGlobalStore}>
      <RouterProvider router={router} />
    </ProviderCallPopUpGlobal>
  </ProviderEntities>
)
